import { useEffect, useState } from 'react';
import type { ResolvedScheme } from '../../core/theme/useColorScheme';
import { resolveTokenColor } from '@frontend-core/theme/resolveCssColor';

export function useTelegramAppTheme(): ResolvedScheme | undefined {
  const [colorScheme, setColorScheme] = useState<ResolvedScheme | undefined>(() => {
    const webApp = window.Telegram?.WebApp;
    return webApp ? webApp.colorScheme : undefined;
  });

  useEffect(() => {
    const webApp = window.Telegram?.WebApp;
    if (!webApp) {
      return;
    }

    const applyTheme = () => {
      const bgColor = webApp.themeParams.bg_color ?? '#ffffff';
      const textColor = webApp.themeParams.text_color ?? '#121212';
      const secondaryBg = webApp.themeParams.secondary_bg_color ?? '#f4f4f5';
      const accent = webApp.themeParams.button_color ?? '#1f6feb';

      document.documentElement.style.setProperty('--tg-bg', bgColor);
      document.documentElement.style.setProperty('--tg-text', textColor);
      document.documentElement.style.setProperty('--tg-secondary-bg', secondaryBg);
      document.documentElement.style.setProperty('--tg-accent', accent);

      setColorScheme(webApp.colorScheme);
      requestAnimationFrame(() => {
        const themeBackground = resolveTokenColor('--background', bgColor);
        if (typeof webApp.setHeaderColor === 'function') webApp.setHeaderColor(themeBackground);
        if (typeof webApp.setBackgroundColor === 'function')
          webApp.setBackgroundColor(themeBackground);
      });
    };

    webApp.ready();
    webApp.expand();
    applyTheme();

    webApp.onEvent('themeChanged', applyTheme);
    return () => {
      webApp.offEvent('themeChanged', applyTheme);
    };
  }, []);

  return colorScheme;
}
